import { useEffect } from 'react'
import { useRouter } from 'next/router'

import CheckoutPanel from 'checkout/components/CheckoutPanel'
import CreditCardVerification from 'checkout/components/PaymentMethodPanel/CreditCardVerification'
import NewCardNewAddressForm from 'checkout/components/PaymentMethodPanel/NewCardNewAddressForm'
import PaymentMethodSummary from 'checkout/components/PaymentMethodPanel/PaymentMethodSummary'
import SavedPaymentMethodsForm from 'checkout/components/PaymentMethodPanel/SavedPaymentMethodsForm'
import { AddressFormContextProvider } from 'checkout/containers/AddressFormContextProvider'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { SVGIcon } from 'shared/components/Icons'
import { CheckoutQA } from 'shared/dataAttributes'
import styled from 'styled-components'
import { t } from 'localization'

const TP = 'checkout.components.PaymentMethodPanel.PaymentMethodPanel'

const Title = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
`
const LockIcon = styled(SVGIcon).attrs({
  name: 'lock',
})`
  margin-right: 10px;
`

const PaymentMethodPanel = () => {
  const { panels } = useCheckoutContext()

  const getPaymentMethodView = () => {
    switch (panels.paymentMethod.view) {
      case 'new':
        return <NewCardNewAddressForm />
      case 'saved':
        return <SavedPaymentMethodsForm />
      case 'verification':
        return <CreditCardVerification />
    }
  }

  return (
    <AddressFormContextProvider>
      <CheckoutPanel
        name="paymentMethod"
        title={
          <Title>
            <LockIcon />
            {t(`${TP}.paymentMethod`, 'Payment Method')}
          </Title>
        }
        qaAttr={CheckoutQA.PaymentMethod}
        expandedContent={getPaymentMethodView()}
        summarizedContent={<PaymentMethodSummary />}
      />
    </AddressFormContextProvider>
  )
}

export default PaymentMethodPanel
